module.exports = __webpack_public_path__ + "components/country-flag/static/eu-0420e634b15c416fbdc13765fa79dc19.svg";